var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLoginGoogle = function SvgIconLoginGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M17.393 9.15a10.2 10.2 0 0 0-.16-1.812h-8.32v3.426h4.754a4.074 4.074 0 0 1-1.763 2.673v2.221h2.855c1.67-1.541 2.634-3.811 2.634-6.508Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M8.974 17.8c2.36 0 4.34-.796 5.786-2.153l-2.826-2.23c-.782.533-1.784.848-2.96.848-2.278 0-4.205-1.564-4.893-3.665h-2.92v2.303C2.598 15.808 5.555 17.8 8.973 17.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M4.115 10.692A5.46 5.46 0 0 1 3.84 9c0-.587.1-1.158.274-1.692V5H1.202a9.06 9.06 0 0 0-.927 4 9.06 9.06 0 0 0 .927 4l2.913-2.308Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M9.029 3.736c1.293 0 2.453.448 3.366 1.329l2.525-2.55C13.395 1.081 11.402.2 9.03.2 5.587.2 2.609 2.192 1.16 5.097L4.102 7.4c.692-2.1 2.633-3.664 4.927-3.664Z"
  })));
};
export default SvgIconLoginGoogle;